import { BaseModalComponent } from "../common/BaseModalComponent";

/** Single app-wide host so openModal(RelatedDepositInvoice, <InvoiceDetailsView />) always has a renderer. */
export const RELATED_DEPOSIT_INVOICE_MODAL_KEY = "RelatedDepositInvoice";

export function RelatedDepositInvoiceModalHost() {
  return (
    <BaseModalComponent
      modalKey={RELATED_DEPOSIT_INVOICE_MODAL_KEY}
      modalLabel="Deposit invoice"
      preventParentTrigger
      defaultSizes={{
        width: { xs: "95%", sm: "88%", md: "75%", lg: "720px" },
        height: { xs: "90%", sm: "85%", md: "80%", lg: "720px" },
      }}
    />
  );
}
